module.exports = __webpack_public_path__ + "img/no_internet_light.b8be5a00.svg";